// extracted by mini-css-extract-plugin
module.exports = {"StudiesModuleSubjectForm":"style_StudiesModuleSubjectForm__2PtFH","titleWrapper":"style_titleWrapper__Nzov7","contentWrapper":"style_contentWrapper__2iFeE"};